const PHONE_NUMBER_LENGTH_NO_COUNTRY_CODE = 10;

// format as +1xxxxxxxxxx
export const formatPhoneNumberIDE64 = (phoneNumber, countryCode = "1") => {
  const ide64 = /^\+[1-9]\d{1,14}$/;
  if (ide64.test(phoneNumber) &&
      phoneNumber.length ===  1 + countryCode.length + PHONE_NUMBER_LENGTH_NO_COUNTRY_CODE) {
    return phoneNumber;
  }
  const cleaned = (phoneNumber || "").replace(/[^0-9]+/g, "");
  if (cleaned.length === PHONE_NUMBER_LENGTH_NO_COUNTRY_CODE){
    return `+${countryCode}${cleaned}`;
  }
  return null;
};